import { on, ready } from "../utils/listeners";

ready(() => {
  on("click", ".js-favourites-trigger");

  const heartIconContainer = document.querySelector(".mini-heart-container");
  const favouritesCount = document.querySelector(".js-favourites-count");

  const performAddAnimation = () => {
    if (!heartIconContainer) return;

    heartIconContainer.classList.remove("animate-removed");
    heartIconContainer.classList.add("animate-added");
    setTimeout(() => {
      heartIconContainer.classList.remove("animate-added");
    }, 1500);
  };

  const performRemoveAnimation = () => {
    if (!heartIconContainer) return;

    heartIconContainer.classList.remove("animate-added");
    heartIconContainer.classList.add("animate-removed");
    setTimeout(() => {
      heartIconContainer.classList.remove("animate-removed");
    }, 1500);
  };

  const updateFavouritesCount = change => {
    if (!favouritesCount) return;

    const current = parseInt(favouritesCount.innerHTML, 10) || 0;
    const updated = Math.max(0, current + change);

    favouritesCount.innerHTML = updated;
    favouritesCount.classList.toggle("hidden", updated < 1);
  };

  window.addEventListener("addedFavourite", () => {
    performAddAnimation();
    updateFavouritesCount(1);
  });

  window.addEventListener("removedFavourite", () => {
    performRemoveAnimation();
    updateFavouritesCount(-1);
  });
});
